/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import Modal from "react-bootstrap/Modal"
import PropTypes from "prop-types"
// import Modal from "react-bootstrap/Modal"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
  Badge,
  // Badge
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as followupMetricsAction from "../../store/Zm9sbG93dXBNZXRya/actions"
import { isEmpty } from "lodash"
import * as salesAction from "../../store/c2FsZXM/actions"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { CSVExport } from "react-bootstrap-table2-toolkit"
// import { get } from "lodash"
// import { toast } from "react-toastify"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import loadertable from "../../assets/images/loader-table.gif"

const FollowupMetrics = (props) => {
  const title = "Followup Metrics"

  const { dispatch, searchBarStyle } = props
  const specificDispatch = useDispatch()

  const { SearchBar } = Search

  //download feature in data table
  const { ExportCSVButton } = CSVExport

  useEffect(() => {
    dispatch(followupMetricsAction.loadRecordsMetaData())
    dispatch(followupMetricsAction.loadFollowupMetrics())
    dispatch(salesAction.loadEmployee())
    setApplyFilter(false)
  }, [])

  // Data table laoder

  const [pageLoading, setPageLoading] = useState(true)

  useEffect(() => {
    setTimeout(() => {
      setPageLoading(false)
    }, 2000)
  }, [1])

  const update = useSelector((specificstate) => specificstate)
  console.log("update is", update)

  const salesUpdate = useSelector((specificstate) => specificstate.sales)
  const permissionUpdate = useSelector(
    (specificstate) => specificstate.followupMetrics
  )
  const { employee_list = [] } = salesUpdate
  const { followupMetricsMetaData = {}, followup_metrics = [] } =
    permissionUpdate

  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
  !isEmpty(user) && user.setting && user.setting.dateFormate
    ? user.setting.dateFormate.toUpperCase()
    : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  console.log(followup_metrics.branchName)
  console.log("rejectData is", permissionUpdate)
  const [btnLoader, setBtnLoader] = useState(false)
  const [rejectData, setRejectData] = useState({
    company: [],
    branch: [],
    department: [],
    salesAgent: [],
    fromDate: "",
    toDate: "",
  })
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [openLead, setOpenLead] = useState(false)
  const [followupDetails, setFollowupDetails] = useState("")
  const [callView, setCallView] = useState(false)
  const [callCountDetails, setCallCountDetails] = useState("")

  const handleCallClose = () => setCallView(false)
  const handleOpenLeadClose = () => setOpenLead(false)

  //dropdown options api
  const branchOptions =
    !isEmpty(followupMetricsMetaData) &&
    followupMetricsMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //Employee list
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.empCode = element.empCode
        obj.label = labelEmployee
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  // const employeeOptions = createOptions(employeeList)
  //checking
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)

  const startDate = rejectData.fromDate
  const endDate = rejectData.toDate

  console.log(company, branch, startDate, endDate, "dropdown outputs")

  const handleChange = async (e) => {
    setRejectData({ ...rejectData, [e.target.name]: e.target.value })
  }

  const [applyFilter, setApplyFilter] = useState(false)
  //Apply filter
  const handleFilter = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""

    var searchEmpCode =
      salesAgent && salesAgent.empCode ? salesAgent.empCode : ""

    var searchFromDate =
      rejectData && rejectData.fromDate
        ? moment(rejectData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      rejectData && rejectData.toDate
        ? moment(rejectData.toDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEmpCode) {
      searchvalue.empCode = searchEmpCode
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }

    console.log("searchCompany", searchvalue)
    specificDispatch(followupMetricsAction.loadFollowupMetrics(searchvalue))
    setBtnLoader(true)
    setApplyFilter(true)
    setPageLoading(true)
    setTimeout(() => {
      setPageLoading(false)
      setBtnLoader(false)
    }, 2000)
  }
  const today = moment().format("YYYY-MM-DD")

  console.log()
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setSalesAgent([])
    setRejectData({
      fromDate: today,
      toDate: today,
    })
  }
  // const [approvedData, setApprovedData] = useState("")

  let slNo = 0
  const followupDataTable = !isEmpty(followup_metrics)
    ? followup_metrics.map((leadData, index) => {
        slNo = slNo + 1

        return {
          _id: leadData._id,
          sNo: slNo,
          action: (
            <Button
              type="submit"
              style={{ fontSize: "10px" }}
              className="btn btn-success buttons"
            >
              <i className="fas fa-pen icon-btn"></i>
            </Button>
          ),
          employeeName: leadData.employeeName,
          empCode: leadData.empCode,
          companyName: leadData.companyName,
          branchName: leadData.branchName,
          leadAssign: leadData.leadAssign,
          overallFollowupCount: leadData.overallFutureFollowupCount,
          overallOpenLead: leadData.overallOpenLeadCount?leadData.overallOpenLeadCount:"",
          followupCount: leadData.FutureFollowupCount,
          pendingFollowup: leadData.pendingFollowupCount,
          rejectCount: leadData.rejectLeadCount!=undefined?leadData.rejectLeadCount:'--',
          leadStatus: (
            <Badge
              className={`font-size-12 badge rounded-pill ${
                leadData.processStatusName === "Rejected"
                  ? "bg-danger badge-soft-danger"
                  : "bg-success badge-soft-success"
              }`}
              pill
            >
              {leadData.processStatusName}
            </Badge>
            // <span style={{ color: "#f33232" }}>
            //   {leadData.processStatusName}
            // </span>
          ),
          openLeads: (
            <button
              className="lead-btn"
              onClick={() => {
                setOpenLead(true)
                setFollowupDetails(leadData.overallOpenLead)
              }}
            >
              Open Leads
            </button>
          ),
          callCount: (
            <div className="d-flex flex-row justify-content-center">
              <p style={{ fontSize: "12px", marginTop: "6px" }}>
                {leadData.callCount}
              </p>
              <i
                className="fas fa-eye icon-btn mx-3"
                style={{ fontSize: "16px", color: "#3498db", marginTop: "6px" }}
                onClick={() => {
                  setCallView(true)
                  setCallCountDetails(leadData.callCountArray)
                }}
              ></i>
            </div>
          ),
          callCountExcelValue:leadData.callCount,
          remarks: leadData.remarks,
          fileName: (
            <a onClick={() => window.open(leadData.rejectAttachment, "_blank")}>
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View Attachments
              </span>
            </a>
          ),
          leadDate: leadData.leadDate
            ? moment(leadData.leadDate).format("DD-MM-YYYY hh:mm A")
            : [],
          key: index,
        }
      })
    : []

  //pagination table data columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "overallFollowupCount",
      text: "Overall Followup Count",
      sort: true,
      headerStyle: {
        minWidth: "205px",
      },
    },
    {
      dataField: "overallOpenLead",
      text: "Overall Open Lead",
      sort: true,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "openLeads",
      text: "View Open Leads",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "followupCount",
      text: "Followup Count",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "pendingFollowup",
      text: "Pending Followup",
      sort: true,
      headerStyle: {
        minWidth: "163px",
      },
    },
    {
      dataField: "rejectCount",
      text: "Reject Count",
      sort: true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "callCount",
      text: "No of Calls(Current Followup)",
      sort: true,
      csvExport: false,
      headerStyle: {
        minWidth: "242px",
      },
    },
    {
      dataField: "callCountExcelValue",
      text: "No of Calls(Current Followup)",
      sort: true,
      hidden:true,
      headerStyle: {
        minWidth: "242px",
      },
    },
  ]

  const options = {
    sizePerPage: 25,
    totalSize: followup_metrics.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  console.log(today, "today")
  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setRejectData({
          ...rejectData,
          fromDate: today,
          toDate: today,
        })
      }
    }, 3000)
  }, [applyFilter])
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            followupMetricsMetaData
                              ? followupMetricsMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <Label className={"form-label"}>
                          {"Employee Name"}
                        </Label>

                        <ReactSearchAutocomplete
                          name="salesAgent"
                          items={employeeOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter Sales Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Lead Followup From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={rejectData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"Lead Followup To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={rejectData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="button"
                            onClick={() => handleFilter()}
                            className="btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  {pageLoading ? (
                    <div className="d-flex flex-column">
                      <Col className="mb-3 search-bar">
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div
                            className="position-relative mt-3"
                            style={searchBarStyle || null}
                          >
                            <SearchBar />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </Col>
                      <Col md="12" xl="12" lg="12">
                        {/* <p className="card-text placeholder-glow">
                      <span className="placeholder col-7"></span>
                    </p> */}
                        <Table responsive>
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th style={{ minWidth: "150px" }}>Lead No</th>
                              <th style={{ minWidth: "150px" }}>
                                Employee Name
                              </th>
                              <th style={{ minWidth: "150px" }}>Company</th>
                              <th style={{ minWidth: "150px" }}>Branch</th>
                              <th style={{ minWidth: "210px" }}>
                                Overall Followup Count
                              </th>
                              <th style={{ minWidth: "150px" }}>
                                Overall Open Lead
                              </th>
                              <th style={{ minWidth: "150px" }}>
                                View Open Leads
                              </th>
                              <th style={{ minWidth: "150px" }}>
                                Followup Count
                              </th>
                              <th style={{ minWidth: "212px" }}>
                                Pending Followup
                              </th>
                              <th style={{ minWidth: "212px" }}>
                                Reject Count
                              </th>
                              <th style={{ minWidth: "252px" }}>
                                No of Calls(Current Followup)
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan="19">
                                <img
                                  src={loadertable}
                                  style={{ width: "100%", height: "230px" }}
                                />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </Col>
                      <Row
                        style={{ marginTop: "5px" }}
                        className="align-items-md-center mt-30"
                      >
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline d-flex flex-row">
                            {/* <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                            <div
                              style={{
                                fontSize: "14px",
                                marginTop: "8px",
                                marginLeft: "4px",
                              }}
                            >
                              Showing rows 0 to 0 of 0
                            </div>
                          </div>
                          <div
                            className="text-md-right ms-auto"
                            style={{ zIndex: 0 }}
                          >
                            <PaginationListStandalone />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <PaginationProvider
                      pagination={paginationFactory(options)}
                      keyField="_id"
                      columns={columns}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          data={followupDataTable}
                          columns={columns}
                          search
                        >
                          {(props) => (
                            <div>
                              <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                <Row className="d-flex flex-row">
                                  <Col className="mb-3">
                                    <div className="d-flex flex-row">
                                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                        <div
                                          className="position-relative mt-7"
                                          style={searchBarStyle || null}
                                        >
                                          <SearchBar {...props.searchProps} />
                                          <i className="bx bx-search-alt search-icon" />
                                        </div>
                                      </div>
                                    </div>{" "}
                                  </Col>
                                  <Col>
                                    <ExportCSVButton
                                      className="border float-right mx-10"
                                      style={{
                                        float: "right",
                                        backgroundColor: "#e40d8c",
                                        color: "#ffffff",
                                      }}
                                      {...props.csvProps}
                                    >
                                      Download{" "}
                                    </ExportCSVButton>
                                  </Col>
                                 
                                </Row>
                                <Row>
                                <Col>
                                    <BootstrapTable
                                      {...props.baseProps}
                                      responsive
                                      noDataIndication={"No Data Found..."}
                                      striped={true}
                                      bordered={true}
                                      {...paginationTableProps}
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  style={{ marginTop: "5px" }}
                                  className="align-items-md-center mt-30"
                                >
                                  <Col className="inner-custom-pagination d-flex">
                                    <div className="d-inline d-flex flex-row">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          marginTop: "8px",
                                          marginLeft: "4px",
                                        }}
                                      >
                                        <PaginationTotalStandalone
                                          {...paginationProps}
                                        />
                                      </div>
                                    </div>
                                    <div
                                      className="text-md-right ms-auto"
                                      style={{ zIndex: 0 }}
                                    >
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {openLead && (
          <Modal show={openLead} size="lg" onHide={handleOpenLeadClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col xl="12" md="12" lg="12" sm="12" xs="12">
                <div className="d-flex flex-row justify-content-between">
                  <span>LEAD DETAILS</span>
                  <span className="float-right">
                    <i
                      className="fa fa-times"
                      aria-hidden="true"
                      onClick={handleOpenLeadClose}
                      style={{
                        cursor: "pointer",
                      }}
                    ></i>
                  </span>
                </div>
              </Col>
            </Modal.Header>
            <Modal.Body
              style={{
                height: "80%",
              }}
            >
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "109px" }}>Lead No</th>
                          <th style={{ minWidth: "109px" }}>Company</th>
                          <th style={{ minWidth: "109px" }}>Branch</th>
                          <th style={{ minWidth: "109px" }}>Client Name</th>
                          <th style={{ minWidth: "110px" }}>Lead Date</th>
                          {/* <th style={{ minWidth: "110px" }}>Followup Time</th> */}
                          <th style={{ minWidth: "170px" }}>Status</th>
                          <th style={{ minWidth: "60px" }}>Lead Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {followupDetails && followupDetails.length > 0 ? (
                          followupDetails.map((followup, index) => {
                           
                            var leadDate = !isEmpty(followup.leadDate)
                              ? moment(followup.leadDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format(`${dateFormate} hh:mm A`)
                              : []
                            return (
                              <tr key={followup._id}>
                                <td>{index + 1}</td>
                                <td
                                  style={{
                                    textTransform: "uppercase",
                                    color: "#E40D8C",
                                  }}
                                >
                                  {followup.leadNo}
                                </td>
                                <td>{followup.companyName}</td>
                                <td>{followup.branchName}</td>
                                <td>{followup.clientName}</td>
                                <td style={{ minWidth: "110px" }}>
                                  {!isEmpty(followup.leadDate)
                                    ? leadDate
                                    : "--"}
                                </td>
                                <td style={{ minWidth: "110px" }}>
                                  {followup.processStatusName}
                                </td>
                                <td>{followup.leadType}</td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td colSpan={8} className="text-align-center">
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="button"
                onClick={() => {
                  // deleteNightshift()
                  setOpenLead(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {callView && (
          <Modal show={callView} size="lg" onHide={handleCallClose}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                minHeight: "65px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              <Col xl="12" md="12" lg="12" sm="12" xs="12">
                <div className="d-flex flex-row justify-content-between">
                  <span>CALL DETAILS</span>
                  <span className="float-right">
                    <i
                      className="fa fa-times"
                      aria-hidden="true"
                      onClick={handleCallClose}
                      style={{
                        cursor: "pointer",
                      }}
                    ></i>
                  </span>
                </div>
              </Col>
            </Modal.Header>
            <Modal.Body style={{ height: "80%" }}>
              <Col>
                <Row className="d-flex flex-column">
                  {/* <div>No Records Found</div> */}
                  <Col xl="12" lg="12" md="12" sm="12" xs="12">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "20px" }}>S.No</th>
                          <th style={{ minWidth: "109px" }}>Lead No</th>
                          <th style={{ minWidth: "109px" }}>Company</th>
                          <th style={{ minWidth: "109px" }}>Branch</th>
                          <th style={{ minWidth: "109px" }}>Client Name</th>
                          <th style={{ minWidth: "110px" }}>Lead Date</th>
                          <th style={{ minWidth: "170px" }}>Status</th>
                          <th style={{ minWidth: "109px" }}>Attachment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {callCountDetails.length > 0 ? (
                          callCountDetails.map((event, index) => {
                            // let slNo = 0
                            const dateFormate =
                              !isEmpty(dateSetting) && dateSetting
                                ? dateSetting
                                : ""
                            var leadDate = !isEmpty(event.leadDate)
                              ? moment(event.leadDate)
                                  .subtract(5, "hours")
                                  .subtract(30, "minutes")
                                  .format(`${dateFormate} hh:mm A`)
                              : []
                            console.log(event, "request from data table leave")
                            const attachments = !isEmpty(event)
                              ? event.recordAttachment.map((record) =>
                                  record.split(".").pop()
                                )
                              : []
                            console.log(
                              attachments,
                              "attachment from callCountDetails"
                            )
                            return (
                              <tr key={event._id}>
                                <td>{index + 1}</td>
                                <td
                                  style={{
                                    color: "#E40D8C",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {event.leadNo}
                                </td>
                                <td>{event.companyName}</td>
                                <td>{event.branchName}</td>
                                <td>
                                  { event.firstName +
                                      " " +
                                      event.lastName
                                  }
                                </td>
                                <td>{leadDate}</td>
                                <td>{event.processStatusName}</td>
                                <td>
                                  {(event.recordAttachment.length > 0 &&
                                    attachments[0] === "jpeg") ||
                                  (event.recordAttachment.length > 0 &&
                                    attachments[0] === "jpg") ||
                                  (event.recordAttachment.length > 0 &&
                                    attachments[0] === "png") ? (
                                    <a
                                      onClick={() =>
                                        window.open(
                                          event.recordAttachment,
                                          "_blank"
                                        )
                                      }
                                    >
                                      <span
                                        style={{
                                          textDecoration: "underline",
                                          color: "#E40D8C",
                                        }}
                                      >
                                        View
                                      </span>
                                    </a>
                                  ) : (event.recordAttachment.length > 0 &&
                                      attachments[0] === "mp3") ||
                                    (event.recordAttachment.length > 0 &&
                                      attachments[0] === "m4a") ||
                                    (event.recordAttachment.length > 0 &&
                                      attachments[0] === "mp4") ? (
                                    <a href={event.recordAttachment}>
                                      <audio controls>
                                        <source
                                          src={event.recordAttachment}
                                          type="audio/mpeg"
                                        />
                                        Your browser does not support the audio
                                        element.
                                      </audio>
                                    </a>
                                  ) : (
                                    ""
                                  )}
                                </td>
                              </tr>
                            )
                          })
                        ) : (
                          <>
                            <tr key={0}>
                              <td colSpan={8} className="text-align-center">
                                No Records Found
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button
                type="button"
                onClick={() => {
                  setCallView(false)
                }}
                style={{ marginLeft: "15px" }}
                className="btn btn-danger buttons"
              >
                Cancel
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    </React.Fragment>
  )
}

FollowupMetrics.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FollowupMetrics)
)
